import { HandySvg } from "handy-svg";
import style from "./BottomBanner.module.scss";

function BottomBanner({ dictionary }) {
	return (
		<section className={style.container}>
			<div className={style.text}>
				<p className={style.title} dangerouslySetInnerHTML={{ __html: dictionary["page_affiliate_block4_header"] || "Ready to become a BgRem affiliate?" }} />
				<HandySvg className={`${style.lineIcon} ${style.desktop}`} src={"/main_page/bottom_banner/dotted_line.svg"} width={433} height={124} />
				<HandySvg className={`${style.lineIcon} ${style.adaptive}`} src={"/main_page/bottom_banner/round_line.svg"} width={90} height={202} />
			</div>
			<a href="https://bgrem.firstpromoter.com/" target="_blank" rel="noreferrer" className={style.btn}>
				{dictionary["page_affiliate_but"] || "Apply now"}
			</a>
		</section>
	);
}

export default BottomBanner;
